import { useNavigate } from 'react-router-dom';

import { KioskButton } from '../components/KioskButton';
import { KioskFrame } from '../components/KioskFrame';
import { Mascot } from '../components/Mascot';
import { OptionCard } from '../components/OptionCard';
import { useKiosk } from '../lib/session';

/**
 * 規則式 FAQ scaffold — 對應 Flow 3.5 註：
 *   「若 C-3 契約未完成（資料地域 / DPA / 紅化），此頁不顯示『同意並繼續』，
 *    UI 落到規則式 FAQ。」
 *
 * 目前 C-3 LLM 廠商簽約阻斷（見 invoice_payment_blocked_on_vendor memory
 * 同類受阻 pattern）。語音識別不可用，但「用講的」按鈕仍提供有意義的 fallback：
 * 常見問題清單一鍵跳對應流程（同 C-2 小獅船長精神）。
 *
 * 串到真實語音時改成：
 *   - 顯示「同意並繼續」CTA → /voice/consent → /voice/interact
 *   - 語音識別後落到 recommendations / browse / checkin 同步路徑
 */
export function VoiceScreen(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useKiosk();

  const questions: { key: string; to: string }[] = [
    { key: 'voice.q1', to: '/browse' },
    { key: 'voice.q2', to: '/recommend' },
    { key: 'voice.q3', to: '/browse' },
    { key: 'voice.q4', to: '/checkin' },
  ];

  return (
    <KioskFrame>
      <div className="k-row" style={{ alignItems: 'center', marginBottom: 16 }}>
        <h1 className="k-h1">{t('voice.title')}</h1>
        <Mascot size={120} pose="wave" />
      </div>

      <p className="k-text" style={{ color: 'var(--c-primary)', marginBottom: 16 }}>
        {t('voice.unavailable')}
      </p>

      {questions.map((q) => (
        <OptionCard key={q.key} title={t(q.key)} onClick={() => navigate(q.to)} />
      ))}

      <p className="k-text k-text--dim" style={{ marginTop: 12 }}>
        {t('voice.contractNote')}
      </p>

      <div className="k-footbar">
        <KioskButton variant="secondary" onClick={() => navigate('/home')}>
          ← {t('common.home')}
        </KioskButton>
      </div>
    </KioskFrame>
  );
}
